export const globalConstant = {
  COLOR_PINK: "#EC2E7B",
  COLOR_LITE: "#F9F1F5",
  BOARDER_THIK: "5px",
  BOARDER_THIN: "2px",
  TRESTLE_TABLE_PRICE: "Trestle Table",
  BANNER_RAIL_FOR_TENTS_PRICE: "Bannerrails",
  ADDITIONAL_PASSES_PRICE: "Additional Passes",
  AMP_13_TWIN_SOCKETS_PRICE: "13 amp twin sockets",
  AMP_16_PRICE: "16 amp single",
  AMP_32_PRICE: "32 amp single",
  //Cost_1x16_Single: "Cost 1x16 Single",
  // Cost_1x32_Single: "Cost 1x32 Single",
  ADMIN_RETAIL_FEE: "Admin Fee-Retailers",
  //ADMIN_FEE: "Admin Fees",
  PROCESS_PERCENT: "Card Payment Processing %",
  VAT_PERCENT: "VAT %",
  TURNOVER_COMMITMENT_FEE: "Turnover Based Rent-Commitment Fee",
  VAT_NUMBER: "VAT Number",
  PRE_EVENT_MESSAGING: "Pre-Event Messaging",
  termsHtmlText: `<p>SWALLOW EVENTS WEBSITE TERMS &amp; CONDITIONS<br />
TERMS &amp; CONDITIONS WHEN USING THE SWALLOW EVENTS WEBSITE</p>

<p>PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS WEBSITE.</p>

<p>Who we are: Our site (www.swallowevents.com/partnerships) is operated by Swallow Bakery Partnerships Ltd (&ldquo;We&rdquo;). Company Number 09403104. To contact us please email info@swallowevents.com.</p>

<p>Swallow Events host schedules and takes bookings for events. Organisers for each event are shown clearly on the schedules where you will also find each events own Terms and Conditions, withdrawal &amp; refund Policies. Please review individual event schedules for their specific details.</p>

<p>By using our site you confirm that you accept these terms of use and that you agree to comply with them.</p>

<p>If you do not agree to these terms, you must not use this site.</p>

<p>3. NON-CIRCUMNAVIGATION<br />
All platform users hereby agrees for himself or herself, their officers, directors, agents, associates and any related parties, that they will not, directly or indirectly, contact, deal with or otherwise become involved with any entity or any other entities or parties introduced, directly or indirectly, by or through the other party, its officers, directors, agents or associates, for the purpose of avoiding the payment to the Company of profits, fees or otherwise, without the specific written approval of the Company.</p>

<p>There are other terms that may apply to you.</p>

<p>4. These terms of use refer to additional policies, which also form part of these terms and apply to your use of our site.</p>

<p>Our Privacy Policy<br />
Our Acceptable Use Policy<br />
c. Our Cookie Policy</p>

<p>5. We may make changes to these terms from time to time. We will notify you if large changes are made. We may also make changes to our site. We will try to give you reasonable notice of any major changes.</p>

<p>6. We may suspend or withdraw our site. Our site is made available free of charge. We do not guarantee that our site, or any content on it, will always be available or be uninterrupted. We may suspend or withdraw or restrict the availability of all or part of our site for business and operational reasons. We will try to give reasonable notice of any suspension or withdrawal.</p>

<p>7. You must keep your account details safe. You must not share these with other people. We have the right to disable any user password, whether chosen by you or allocated by us, at any time, if in our reasonable opinion you have failed to comply with any of the provision of these terms of use.</p>

<p>HOW YOU CAN USE MATERIAL ON OUR SITE.</p>

<p>8. We are the owner of all intellectual property rights on our site, and the material published on it. These are protected by copyright laws and treaties around the world. All such rights are reserved. You may print off one copy, and download extracts from our site for your personal use. You may not modify any of the materials you have printed off or downloaded. You must identify Swallow Events as owners of this material.</p>

<p>9. You must nor use any part of the content on our site for commercial purposes without permission.</p>

<p>10. We will make all reasonable efforts to update the information on our site but we do not make representations, warranties or guarantees, whether expressed or implied, that the content on our site is accurate, complete or up to date.</p>

<p>We are not responsible for the websites we link to. These links are provided for information only.</p>

<p>ENTERING EVENTS &ndash; YOU WILL BE ABLE TO ENTER EVENTS ORGANISED BY OURSELVES AND THIRD PARTIES.</p>

<p>11. You are entirely responsible for the content of your entry. These can be seen in your Swallow Events user account.</p>

<p>12. Upon entering an event the contract exists between you and the event organiser.&#8232;<br />
13. We have no involvement in the fulfilment of events and/or your entry into those events.&#8232;<br />
14. Booking Fees are non-refundable in any circumstances.</p>

<p>OUR RESPONSIBILITY FOR LOSS OR DAMAGE SUFFERED BY YOU</p>

<p>OUR RESPONSIBILITY FOR LOSS OR DAMAGE SUFFERED BY YOU, WHETHER YOU ARE A CONSUMER OR A BUSINESS USER.</p>

<p>15. We do not exclude or limit in any way our liability to you where it would be unlawful to do so. This includes liability for death or personal injury caused by our negligence or the negligence or our employees, agents or subcontractors and for fraud or fraudulent misrepresentation.</p>

<p>IF YOU ARE A BUSINESS USER</p>

<p>16. We exclude all implied conditions, warranties, representations or other terms that may apply to our site or any content on it.</p>

<p>17. We will not be liable to you for any loss or damage, whether in contract, tort (including negligence), breach of statutory duty, or otherwise, even if foreseeable, arising under or in connection with:</p>

<p>a. Use of, or inability to use, our site<br />
b. Use of or reliance on any content displayed on our site particular, we will not be liable for<br />
In particular, we will not be liable for<br />
c. Loss of profits, sales business or revenue Business interruption<br />
d. Loss of anticipated savings&#8232;e. Loss business opportunity, goodwill or reputation<br />
f. Any indirect or consequential loss or damage.</p>

<p>IF YOU ARE A CONSUMER USER</p>

<p>18. You agree not to use our site for any commercial or business purposes and we have no liability to you for any loss of profit, loss of business, business interruption or loss of business opportunity.</p>

<p>19. If defective digital content that we have supplied, damages a device or digital content belonging to you and this is caused buy our failure to use reasonable care and skill, we will either repair the damage or pay you compensation. However, we will not be liable for damage that you could have avoided.</p>

<p>WE ARE NOT RESPONSIBLE FOR VIRUSES AND YOU MUST NOT INTRODUCE THEM</p>

<p>20. We do not guarantee that our site will be secure or free from bugs or viruses.&#8232;<br />
21. You are responsible for configuring your IT systems to access our site and should use your own virus protection software.</p>

<p>22. You must not attempt to gain unauthorised access to our site or server.</p>`,

  CatersSignPdfHTML: `
<!doctype html>
<html lang="en">

<head>
  <meta charset="UTF-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <script src="html2pdf.bundle.min.js"></script>
  <link rel="stylesheet" href="style.css" />
  <title>Mobile Catering Booking Form</title>
  <style>
    #reportBody {
      padding: 0;
      margin: 0;
      /* overflow: hidden; */
      box-sizing: border-box;
    }

    @page {
      margin: 20px;
      /* Removes page margins in the PDF */
    }

    /* .page-break {
          page-break-after: always;
          margin: 0 !important;
          padding: 0 !important;
          height: 0 !important;
      } */

    table {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
    }

    td {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 5px;
      font-size: 12px;
    }

    th {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 5px;
      font-size: 12px;
    }

    .paracasalogo {
      height: 60px;
      padding: 0px;
      text-align: center;
    }

    .mainhead {
      padding: 0%;
      color: #e02527;
    }



    .footer2 {
      display: flex;
    }

    .rr {
      font-size: 9px;
      padding: 1px;
    }

    .f1 {
      width: 6rem;
    }


    .checkList {
      padding: 0px;
      width: 36%;
      /* margin-left: -15px; */
    }

    .hardwareName {
      padding: 0px;
      width: 37%;
    }

    .totalQuantity {
      width: 30%;
      padding: 0px;
      margin-top: 29px;
    }
  </style>
</head>

<body>
  <div id="reportBody">
    <!-- first Block -->
    <div style="page-break-after: always !important;">
      <table style="border-collapse: collapse; border: none;">
        <tr>
          <td style="text-align: center; height: 110px; border: none;">
            <img
                style="height: 100px;display: block;margin: 0 auto;border: 0;outline: none;"
                src="@businessLogoUrl@"
                alt="GWCT Logo"
              />
          </td>
        </tr>
        <tr>
          <td style="text-align: center; height: 100px; border: none; ">
            <img
                style="height: 100px; display: block;margin: 0 auto;border: 0;"
                src="/swallow-events-contract.jpg"
                alt="GWCT Logo"
              />
          </td>
        </tr>
        <tr>
          <td style="text-align: center; border: none;">
            <h2 class="mainhead">@busniessName@</h2>
          </td>
        </tr>
        <tr>
          <td style="text-align: center; border: none;">
            <h2>Mobile Catering Booking Form</h2>
          </td>
        </tr>
      </table>
      <p> </p>
      <table>
        <tr style="text-align: left;">
          <td style="text-align: center; border: none;" colspan="2">
            <h4 style="font-weight: 500; text-align: left;">
              Busniess Details
            </h4>
          </td>
        </tr>
        <tr>
          <th>Company Name</th>
          <td>@componyName@</td>
        </tr>
        <tr>
          <th>Contact Name</th>
          <td>@contactName@</td>
        </tr>
        <tr>
          <th>Address</th>
          <td>@address@</td>
        </tr>
        <tr>
          <th>Email Address</th>
          <td>@emailAddress@</td>
        </tr>
        <tr>
          <th>Phone/Mobile Number</th>
          <td>@phone@</td>
        </tr>
        <tr>
          <th>On Site Contact</th>
          <td>@onsiteContact@</td>
        </tr>
        <tr>
          <th>On Site Tel</th>
          <td>@onsiteTel@</td>	
        </tr>
      </table>
      <p>&nbsp;</p>
      <table>
        <tr>
          <td style="text-align: left; border: none;" colspan="5">
            <h4 style="font-weight: 500; text-align: left;">
              Number of units and Fee
            </h4>
          </td>
        </tr>
        <tr>
          <th>UNIT</th>
          <th>FACILITY FEE</th>
          <th>VAT @ @vat@ %</th>
          <th>TOTAL</th>
          <th>CONCESSION FEE</th>
        </tr>
       
          @units@
       
      </table>
      <p>&nbsp;</p>
      <div>
        <table>
          <tr>
            <td style="text-align: left;border: none;" colsapn="4">
              <h4 style="font-weight: 500; text-align: left;">
                Unit Dimensions
              </h4>
            </td>
          </tr>
        </table>
        <table>
          <tr>
            <th>UNIT LENGTH(m)</th>
            <th>UNIT WIDTH(m)</th>
            <th>BACK OF HOUSE LENGTH(m)</th>
            <th>BACK OF HOUSE WIDTH(m)</th>
          </tr>
           @Dimesion@ 
        </table>
      </div>
      <p>&nbsp;</p>
      <table>
        <tr>
          <th>Expected arrival date to site your unit</th>
          <td>@expectedArrivalDate@</td>
        </tr>
        <tr>
          <th>Expected arrival time to site your unit</th>
          <td>@expectedArrivalTimeStr@</td>
        </tr>
      </table>
    </div>
    <!-- 2nd block -->
    <div style="page-break-after: always !important;">
      <table style="border-collapse: collapse; border: none;">
        <tr>
          <td style="text-align: center; height: 110px; border: none;">
            <img
                style="height: 100px;display: block;margin: 0 auto;border: 0;outline: none;"
                src="@businessLogoUrl@"
                alt="GWCT Logo"
              />
          </td>
        </tr>
        <tr>
          <td style="text-align: center; height: 100px; border: none; ">
            <img
                style="height: 100px; display: block;margin: 0 auto;border: 0;"
                src="/swallow-events-contract.jpg"
                alt="GWCT Logo"
              />
          </td>
        </tr>
        <tr>
          <td style="text-align: center; border: none;">
            <h2 class="mainhead">@busniessName@</h2>
          </td>
        </tr>
        <tr>
          <td style="text-align: left; border: none;">
            <h4 style="font-weight: 500; text-align: left;">
              Mobile Food Hygiene And Health And Safety Required Information
            </h4>
          </td>
        </tr>
      </table>
      <div>@document@</div>
      <p></p>
      <table>
        <tr>
          <td style="text-align: left;border: none;" colspan="5">
            <h4 style="font-weight: 500; text-align: left;">
              Power Requirements
            </h4>
          </td>
        </tr>
      </table>
      <div>
    
          @connections@
      
      </div>
    </div>
    <!-- 3rd block -->
    <div>
      <table style="border-collapse: collapse; border: none;">
        <tr>
          <td style="text-align: center; height: 110px; border: none;">
            <img
                style="height: 100px;display: block;margin: 0 auto;border: 0;outline: none;"
                src="@businessLogoUrl@"
                alt="GWCT Logo"
              />
          </td>
        </tr>
        <tr>
          <td style="text-align: center; height: 100px; border: none; ">
            <img
                style="height: 100px;display: block;margin: 0 auto;border: 0;"
                src="/swallow-events-contract.jpg"
                alt="GWCT Logo"
              />
          </td>
        </tr>
        <tr>
          <td style="text-align: center; border: none;">
            <h2 class="mainhead">@busniessName@</h2>
          </td>
        </tr>
        <tr>
          <td style="text-align: left; border: none;" colspan="2">
            <h4 style="font-weight: 500; text-align: left;">
              Pass Requirements
            </h4>
          </td>
        </tr>
      </table>
      <table>
        <tr>
          <th>PASS</th>
          <th>QTY</th>
        </tr>
        <tr>
          <td>
            STAFF BUILD UP AND BREAKDOWN WRISTBAND (valid excluding event
            days)
          </td>
          <td>@staffBuildWristband@</td>
        </tr>
        <tr>
          <td>
            SITE ACCESS BUILD UP AND BREAKDOWN VEHICLE PASS(valid excluding
            event days)
          </td>
          <td>@siteVehiclePass@</td>
        </tr>
        <tr>
          <td>SERVICE SITE ACCESS LABEL VEHICLE PASS</td>
          <td>@serviceVehiclePass@</td>
        </tr>
        <tr>
          <td>MOBILE CATERER EVENT WRISTBAND(valid event days only)</td>
          <td>@mceWristband@</td>
        </tr>
      </table>
    </div>
    <p>&nbsp;</p>
     @backupVehicles@
    <p>&nbsp;</p>
    <div>
      <table>
        <tr>
          <td style="text-align: left; border: none;" colspan="4">
            <h4>Prices</h4>
          </td>
        </tr>
      </table>
      <table>
        <tr>
          <th>ITEM</th>
          <th>AMOUNT</th>
          <th>VAT</th>
          <th>TOTAL</th>
        </tr>
        @tableHeader@ 
      </table>
    </div>
    <p></p>
    <div>
      <div>
        <h4 style="text-align: center;">
          I confirm that I have read, understood and agree to comply fully
          with the terms and conditions of contracts for space for Caterers
        </h4>
      </div>
      

      <table>
        <tr>
          <th>NAME</th>
          <td>@name@</td>
        </tr>
        <tr>
          <th>SIGNED</th>
          <td></td>
        </tr>
        <tr>
          <th>DATE</th>
          <td>@date@</td>
        </tr>
      </table>
    </div>
  </div>
</body>

</html>
    `,

  ReatiilsSignPDFHTML: `<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <script src="html2pdf.bundle.min.js"></script>
  <link rel="stylesheet" href="style.css" />
  <title>Hardware Report</title>
  <style>
    #reportBody {
      padding: 20px;
      margin: 0;
      box-sizing: border-box;
    }

    table {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
    }

    td {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 5px;
      font-size: 12px;
    }

    th {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 5px;
      font-size: 12px;
    }

    .paracasalogo {
      height: 100px;
      padding: 0px;
    }

    .mainhead {
      padding: 0%;
      color: #e02527;
    }

    .proforma {

      background-color: lightgray;
    }

    .footer1 {
      display: flex;
      width: 100% !important;
      padding: 0px;
      padding-top: 20px;
    }

    .footer2 {
      display: flex;
    }

    .rr {
      font-size: 9px;
      padding: 1px;
    }

    .f1 {
      width: 6rem;
    }


    .checkList {
      padding: 0px;
      width: 36%;

    }

    .hardwareName {
      padding: 0px;
      width: 37%;
    }

    .totalQuantity {
      width: 30%;
      padding: 0px;
      margin-top: 29px;
    }

    .ttbody {

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .tdbody {
      word-wrap: break-word !important;
      white-space: normal !important;

      width: inherit !important;
    }

    .tdddbody {

      word-wrap: break-word;
      white-space: normal;

    }
  </style>
</head>


<body>
  <div id="reportBody">


    <div style="page-break-after: always;">
      <table style="border-collapse: collapse; border: none;">
        <tr>
          <td style="text-align: center;  border: none;">
            <img style="height: 100px;display: block;margin: 0 auto;border: 0;outline: none;" src="@businessLogoUrl@" alt="GWCT Logo">
          </td>
        </tr>
        <tr>
          <td style="text-align: center; height: 100px; border: none; ">
            <img style="height: 100px;display: block;margin: 0 auto;border: 0;" src="/swallow-events-contract.jpg" alt="GWCT Logo">
          </td>
        </tr>

        <tr>
          <td style="text-align: center; border: none;">
            <h2 class="mainhead">@businessName@</h2>
          </td>
        </tr>
        <tr>
          <td style="text-align: center; border: none;">
            <h2>Trader Application Booking Form</h2>
          </td>
        </tr>
      </table>
      &nbsp;

      <div>
        <h2 style="font-weight: 500;">Details</h2>
        <table>
          <tr>
            <td style="width: 30%;">Trading Name</td>
            <td style="width: 70%;">@businessName@</td>
          </tr>
          <tr>
            <td style="width: 30%;">Contact First Name</td>
            <td style="width: 70%;">@contactlegalname@</td>
          </tr>
          <!-- <tr>
            <td style="width: 30%;">Contact Last Name</td>
            <td style="width: 70%;">@contactLastname@</td>
          </tr> -->
          <tr>
            <td style="width: 30%;">Address Line</td>
            <td style="width: 70%;">@address@</td>
          </tr>
          <tr>
            <td style="width: 30%;">Town/City</td>
            <td style="width: 70%;">@city@</td>
          </tr>
          <tr>
            <td style="width: 30%;">Post Code</td>
            <td style="width: 70%;">@zipCode@</td>
          </tr>
          <tr>
            <td style="width: 30%;">Email Address</td>
            <td style="width: 70%;">@email@</td>
          </tr>

          <tr>
            <td style="width: 30%;">Phone/Mobile Number</td>
            <td style="width: 70%;">@phone@</td>
          </tr>

          <tr>
            <td style="width: 30%;">On Site Contact</td>
            <td style="width: 70%;">@onsiteContact@</td>
          </tr>


        </table>
        &nbsp;
      </div>
      <div>
        <table>
          <tr>
            <td colspan="2">
              <h2 style="font-weight: 500;">@describesyourstand@ Facility Fee</h2>
            </td>
          </tr>

           @Pitch@

        </table>
        &nbsp;
      </div>
      <div>
        <table>
          <tr>
            <td colspan="2">
              <h2 style="font-weight: 500;">Additional Costs</h2>
            </td>
          </tr>

          <tr>
            <td style="width: 70%;">Trestle table (£@trestletablePrice@)</td>
            <td style="width: 30%;">@trestletable@</td>
          </tr>

          <tr>
            <td style="width: 70%;">Banner rail for tents (£@bannerrailfortentsPrice@)</td>
            <td style="width: 30%;">@bannerrailfortents@</td>
          </tr>

          <tr>
            <td style="width: 70%;">Additional ground passes - 3 passes are automatically included within your pitch fee
              (@additionalpassesPrice@)</td>
            <td style="width: 30%;">@additionalpasses@</td>
          </tr>
        </table>
        &nbsp;
      </div>

      <div>
        <table>
          <tr>
            <td colspan="2">
              <h2 style="font-weight: 500;">Power Costs</h2>
            </td>
          </tr>

          <tr>
            <td style="width: 70%;">13 amp twin-sockets (£@twinsockets13ampPrice@) </td>
            <td style="width: 30%;">@twinsockets13amp@</td>
          </tr>

          <tr>
            <td style="width: 70%;">16 amp (£@amp16Price@) </td>
            <td style="width: 30%;">@amp16@</td>
          </tr>
          <tr>
            <td style="width: 70%;">32 amp (£@amp32Price@) </td>
            <td style="width: 30%;">@amp32@</td>
          </tr>
        </table>
      </div>

    </div>


    <table style="border-collapse: collapse; border: none;">
      <tr>
        <td style="text-align: center; height: 100px; border: none;">
          <img style="height: 100px;display: block;margin: 0 auto;border: 0;outline: none;" src="@businessLogoUrl@" alt="GWCT Logo">
        </td>
      </tr>
      <tr>
        <td style="text-align: center; height: 100px; border: none; ">
          <img style="height: 100px;display: block;margin: 0 auto;border: 0;" src="/swallow-events-contract.jpg" alt="GWCT Logo">
        </td>
      </tr>

      <tr>
        <td style="text-align: center; border: none;">
          <h2 class="mainhead">@businessName@</h2>
        </td>
      </tr>
      <tr>
        <td style="text-align: center;border: none;">
          <h2>Trader Application Booking Form</h2>
        </td>
      </tr>
    </table>

    <p>&nbsp;</p>

    <div>
      <table>
        <tr>
          <td style="text-align: center;">
            <h4>Prices</h4>
          </td>
        </tr>
      </table>

      <table>
        <tr>
          <th>ITEM</th>
          <th>AMOUNT</th>
          <th>VAT</th>
          <th>TOTAL</th>

        </tr>
         @tableHeader@ 
      </table>

    </div>

    <p>&nbsp;</p>

    <!-- 5th Block -->

    &nbsp;
    <div>
      <h4 style="text-align: center;">I confirm that I have read, understood and agree to comply fully with the
        terms and conditions of contracts for space for traders</h4>
    </div>
    &nbsp;
    <table>
      <tr>
        <th>NAME</th>
        <td> @name@ </td>
      </tr>
      <tr>
        <th>SIGNED</th>
        <td> &nbsp; </td>
      </tr>
      <tr>
        <th>DATE</th>
        <td> @date@ </td>
      </tr>
    </table>

  </div>


</body>

</html>`,

  InvoiceHTML: `
<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <link rel="stylesheet" href="costyle.css" />
  <title>Carcass Report</title>

  <style>
    #reportBody {
      padding: 20px;
      margin: 0;
      /* overflow: hidden; */
      box-sizing: border-box;
    }

    table {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
    }

    td {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 5px;
      font-size: 12px;
    }

    th {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 5px;
      font-size: 12px;
    }

    .paracasalogo {
      height: 60px;
      padding: 0px;
      text-align: center;
    }

    .mainhead {
      padding: 0%;
      color: #e02527;
    }



    .footer1 {
      display: flex;
      width: 100% !important;
      padding: 0px;
      padding-top: 20px;
    }

    .footer2 {
      display: flex;
    }

    .rr {
      font-size: 9px;
      padding: 1px;
    }

    .f1 {
      width: 6rem;
    }


    .checkList {
      padding: 0px;
      width: 36%;
      /* margin-left: -15px; */
    }

    .hardwareName {
      padding: 0px;
      width: 37%;
    }

    .totalQuantity {
      width: 30%;
      padding: 0px;
      margin-top: 29px;
    }
  </style>
</head>

<body id="reportBody">
  <!-- Table Header -->
  <table style="border: 1px solid #7B8F96;border-collapse: collapse;">
    <!-- paracasa Logo -->
    <tr>
      <td style="text-align: center; height: 100px;  border: none;">
        <img class="paracasalogo" src="@businessLogoUrl@" alt="invoice"  style="height: 100px; width: 200px;"  />
      </td>
    </tr>
    <tr>
      <td style="text-align: center;border: none;">
        <img style="height: 100px;" src="/swallow-events-contract.jpg" alt="GWCT Logo">
      </td>
    </tr>


    <tr>
      <th style="text-align: center; border: none;" >
        @organiserLegalBusinessName@<br />
         @organiserAddress@<br />         
           @bankDetailsSwallowEO@<br/>
          VAT no: @vatNumber@<br/>
        <p style="text-align: center; text-decoration: underline;">Payment terms: IMPORTANT PLEASE SEE FOOTER</p>
      </th>
    </tr>
  </table>
  <p>&nbsp;</p>
  <!-- ** Table Header End ** -->
  <h1 style="padding:0px;text-align: right; color:#7B8F96;font-weight:bold;">Invoice</h1>
  <!-- 1st Table -->
  <table style="border-collapse: collapse;">
    <tr>
      <td style="width: 58%; border-color: #000000;">
        Bill To:<br/>
          @traderLegalBusinessName@<br/>
          @traderAddress@</td>
      <td style="width: 4%;border-color: #000000; border-left: none; border-right: none;"></td>
      <td style="width: 38%;border-color: #000000;">
        Invoice number: @invoiceNo@<br/>
          @eventName@ <br/>
          @invoiceDate@

      </td>
    </tr>
  </table>
  <p>&nbsp;</p>
  <!-- *********************************************************************** -->
  <table>
    <tbody>
      <!-- <tr> -->
      <tr style="background-color: #f2f2f2;">
        <th> Quantity </th>
        <th> Item </th>
        <th> Description </th>
        <th> Discount </th>
        <th> Taxable </th>
        <th> Unit Price </th>
        <th> Total </th>
      </tr>

       <tr>
        @table@
      </tr> 
    </tbody>
  </table>
  <p>&nbsp;</p>

  <!-- *********************************************************************** -->
  <!-- table 8th -->
  <div class="footer2" style=" width: 100% !important;">
    <div class="terms" style="    width: 65% !important;">
    </div>
    <!-- table 9th -->
    <div style="padding: 0px; width: 35%;">
      <table>
        <tr>
          <th style="font-size: 10px; background-color: #f2f2f2;"> Sub Total :</th>
          <td style="font-size: 9px;background-color: #f2f2f2;">@subTotal@</td>
        </tr>
        <tr>
          <th style="font-size: 10px">Tax : </th>
          <td style="font-size: 9px">@tax@</td>
        </tr>
        <tr>
          <th style="font-size: 10px">Sales Declaration/Litter Bond :</th>
          <td style="font-size: 9px">@litterBond@</td>
        </tr>
        <tr>
          <th style="font-size: 10px; background-color: #f2f2f2;">Balance Due :</th>
          <td style="font-size: 9px; background-color: #f2f2f2;">@balancedue@</td>
        </tr>

      </table>
    </div>
  </div>
  
  <br/>
 @importantnote@
</body>
</html>`,

  InvoiceTicketHTML: `
<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <link rel="stylesheet" href="costyle.css" />
  <title>Carcass Report</title>

  <style>
    #reportBody {
      padding: 20px;
      margin: 0;
      /* overflow: hidden; */
      box-sizing: border-box;
    }

    table {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
    }

    td {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 5px;
      font-size: 12px;
    }

    th {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 5px;
      font-size: 12px;
    }

    .paracasalogo {
      height: 60px;
      padding: 0px;
      text-align: center;
    }

    .mainhead {
      padding: 0%;
      color: #e02527;
    }



    .footer1 {
      display: flex;
      width: 100% !important;
      padding: 0px;
      padding-top: 20px;
    }

    .footer2 {
      display: flex;
    }

    .rr {
      font-size: 9px;
      padding: 1px;
    }

    .f1 {
      width: 6rem;
    }


    .checkList {
      padding: 0px;
      width: 36%;
      /* margin-left: -15px; */
    }

    .hardwareName {
      padding: 0px;
      width: 37%;
    }

    .totalQuantity {
      width: 30%;
      padding: 0px;
      margin-top: 29px;
    }
  </style>
</head>

<body id="reportBody">
  <!-- Table Header -->
  <table style="border: 1px solid #7B8F96;border-collapse: collapse;">
    <!-- paracasa Logo -->
    <tr>
      <td style="text-align: center; height: 100px;  border: none;">
        <img class="paracasalogo" src="@businessLogoUrl@" alt="invoice"  style="height: 100px; width: 200px;"  />
      </td>
    </tr>
    <tr>
      <td style="text-align: center;border: none;">
        <img style="height: 100px;" src="/swallow-events-contract.jpg" alt="GWCT Logo">
      </td>
    </tr>


    <tr>
      <th style="text-align: center; border: none;" >
        @organiserLegalBusinessName@<br />
         @organiserAddress@<br />
          All Payment to be made to: @organiserLegalBusinessName@/g<br/>
          VAT no: @vatNumber@<br/>
        <p style="text-align: center; text-decoration: underline;">Payment terms: IMPORTANT PLEASE SEE FOOTER</p>
      </th>
    </tr>
  </table>
  <p>&nbsp;</p>
  <!-- ** Table Header End ** -->
  <h1 style="padding:0px;text-align: right; color:#7B8F96;font-weight:bold;">Invoice</h1>
  <!-- 1st Table -->
  <table style="border-collapse: collapse;">
    <tr>
      <td style="width: 58%; border-color: #000000;">
        Bill To:<br/>
          @traderLegalBusinessName@<br/>
          @traderAddress@</td>
      <td style="width: 4%;border-color: #000000; border-left: none; border-right: none;"></td>
      <td style="width: 38%;border-color: #000000;">
        Invoice number: @invoiceNo@<br/>
          @eventName@ <br/>
          @invoiceDate@

      </td>
    </tr>
  </table>
  <p>&nbsp;</p>
  <!-- *********************************************************************** -->
  <table>
    <tbody>
      <!-- <tr> -->
      <tr style="background-color: #f2f2f2;">
        <th> Quantity </th>
        <th> Item </th>
        <th> Description </th>
        <th> Discount </th>
        <th> Taxable </th>
        <th> Unit Price </th>
        <th> Total </th>
      </tr>

       <tr>
        @table@
      </tr> 
    </tbody>
  </table>
  <p>&nbsp;</p>

  <!-- *********************************************************************** -->
  <!-- table 8th -->
  <div class="footer2" style=" width: 100% !important;">
    <div class="terms" style="    width: 65% !important;">
    </div>
    <!-- table 9th -->
    <div style="padding: 0px; width: 35%;">
      <table>
        <tr>
          <th style="font-size: 10px; background-color: #f2f2f2;"> Sub Total :</th>
          <td style="font-size: 9px;background-color: #f2f2f2;">@subTotal@</td>
        </tr>
        <tr>
          <th style="font-size: 10px">Tax : </th>
          <td style="font-size: 9px">@tax@</td>
        </tr>
        <tr>
          <th style="font-size: 10px">Sales Declaration/Litter Bond :</th>
          <td style="font-size: 9px">@litterBond@</td>
        </tr>
        <tr>
          <th style="font-size: 10px; background-color: #f2f2f2;">Balance Due :</th>
          <td style="font-size: 9px; background-color: #f2f2f2;">@balancedue@</td>
        </tr>

      </table>
    </div>
  </div>  
</body>
</html>`,

  InvoiceAdminHTML: `
<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <link rel="stylesheet" href="costyle.css" />
  <title>Carcass Report</title>

  <style>
    #reportBody {
      padding: 20px;
      margin: 0;
      /* overflow: hidden; */
      box-sizing: border-box;
    }

    table {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
    }

    td {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 5px;
      font-size: 12px;
    }

    th {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 5px;
      font-size: 12px;
    }

    .paracasalogo {
      height: 60px;
      padding: 0px;
      text-align: center;
    }

    .mainhead {
      padding: 0%;
      color: #e02527;
    }



    .footer1 {
      display: flex;
      width: 100% !important;
      padding: 0px;
      padding-top: 20px;
    }

    .footer2 {
      display: flex;
    }

    .rr {
      font-size: 9px;
      padding: 1px;
    }

    .f1 {
      width: 6rem;
    }


    .checkList {
      padding: 0px;
      width: 36%;
      /* margin-left: -15px; */
    }

    .hardwareName {
      padding: 0px;
      width: 37%;
    }

    .totalQuantity {
      width: 30%;
      padding: 0px;
      margin-top: 29px;
    }
  </style>
</head>

<body id="reportBody">
  <!-- Table Header -->
  <table style="border: 1px solid #7B8F96;border-collapse: collapse;">
    <!-- paracasa Logo -->
   <!-- <tr>
      <td style="text-align: center; height: 100px;  border: none;">
        <img class="paracasalogo" src="@businessLogoUrl@" alt="invoice"  style="height: 100px; width: 200px;"  />
      </td>
    </tr>-->
    <tr>
      <td style="text-align: center;border: none;">
        <img style="height: 100px;" src="/swallow-events-contract.jpg" alt="GWCT Logo">
      </td>
    </tr>


    <tr>
      <th style="text-align: center; border: none;" >
        @organiserLegalBusinessName@<br />
         @organiserAddress@<br />
          All Payment to be made to: @organiserLegalBusinessName@/g<br/>         
          VAT no: @vatNumber@<br/>
        <p style="text-align: center; text-decoration: underline;">Payment terms: IMPORTANT PLEASE SEE FOOTER</p>
      </th>
    </tr>
  </table>
  <p>&nbsp;</p>
  <!-- ** Table Header End ** -->
  <h1 style="padding:0px;text-align: right; color:#7B8F96;font-weight:bold;">Invoice</h1>
  <!-- 1st Table -->
  <table style="border-collapse: collapse;">
    <tr>
      <td style="width: 58%; border-color: #000000;">
        Bill To:<br/>
          @traderLegalBusinessName@<br/>
          @traderAddress@</td>
      <td style="width: 4%;border-color: #000000; border-left: none; border-right: none;"></td>
      <td style="width: 38%;border-color: #000000;">
        Invoice number: @invoiceNo@<br/>
          @eventName@ <br/>
          @invoiceDate@

      </td>
    </tr>
  </table>
  <p>&nbsp;</p>
  <!-- *********************************************************************** -->
  <table>
    <tbody>
      <!-- <tr> -->
      <tr style="background-color: #f2f2f2;">
        <th> Quantity </th>
        <th> Item </th>
        <th> Description </th>
        <th> Discount </th>
        <th> Taxable </th>
        <th> Unit Price </th>
        <th> Total </th>
      </tr>

       <tr>
        @table@
      </tr> 
    </tbody>
  </table>
  <p>&nbsp;</p>

  <!-- *********************************************************************** -->
  <!-- table 8th -->
  <div class="footer2" style=" width: 100% !important;">
    <div class="terms" style="    width: 65% !important;">
    </div>
    <!-- table 9th -->
    <div style="padding: 0px; width: 35%;">
      <table>
        <tr>
          <th style="font-size: 10px; background-color: #f2f2f2;"> Sub Total :</th>
          <td style="font-size: 9px;background-color: #f2f2f2;">@subTotal@</td>
        </tr>
        <tr>
          <th style="font-size: 10px">Tax : </th>
          <td style="font-size: 9px">@tax@</td>
        </tr>
        <tr>
          <th style="font-size: 10px">Sales Declaration/Litter Bond :</th>
          <td style="font-size: 9px">@litterBond@</td>
        </tr>
        <tr>
          <th style="font-size: 10px; background-color: #f2f2f2;">Balance Due :</th>
          <td style="font-size: 9px; background-color: #f2f2f2;">@balancedue@</td>
        </tr>

      </table>
    </div>
  </div>
  <br/> 
</body>
</html>`,

  privacyHtmlText: "",
  aboutHtmlText: "",
  phoneRegex: /\b[\+]?[(]?[0-9]{2,6}[)]?[-\s\.]?[-\s\/\.0-9]{3,15}\b/m,
  emailRegex: /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/,
  passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\-])[A-Za-z\d@$!%*?&\-]{8,}$/,
                
};
